import React from 'react';
import { useActiveElementStore } from 'stores/activeElementStore';
import { useCityParkingStore } from 'stores/cityParkingStore';
import { Maybe, ParkZone } from 'types/generatedSchemaTypes';
import { MarkerTypes } from 'types/MapTypes';
import { getMarkerLetter } from 'utils/cityParkingUtils';
import { isSelectedElement, makePoint } from 'utils/mapUtils';
import AimoMarker from './AimoMarker';

type SelecterMarkerProps = {
  parkingZonesData: Maybe<ParkZone>[] | undefined;
  withLTP?: boolean;
  withCity?: boolean;
};

const SelectedMarker: React.FC<SelecterMarkerProps> = ({
  parkingZonesData,
  withLTP = false,
  withCity = false,
}) => {
  const selectedUid = useActiveElementStore((state) => state.activeElement);
  const selectedPmc = useCityParkingStore((state) => state.selectedPmc);

  if (selectedUid?.length === 0 && withCity && !selectedPmc) {
    return <></>;
  }

  const selectedParkingZone = parkingZonesData?.find((p: ParkZone | null) =>
    isSelectedElement(p?.uid ?? '', selectedUid)
  );
  const {
    address,
    uid,
    locationType,
    commercialZoneView,
    markerType,
    countryCode,
    parkingMethods,
  } = selectedParkingZone || {};

  if (locationType === 'STREET' && countryCode !== 'SE') {
    return null;
  }

  if (address?.marker?.coordinates && uid) {
    const coordinates = makePoint(address?.marker?.coordinates);
    const zoneCode = commercialZoneView?.zoneCode;
    return (
      <AimoMarker
        key={`selected-icon-${uid}`}
        coordinate={coordinates}
        markerType={
          (markerType === 'default' && parkingMethods?.anpr
            ? 'anpr'
            : markerType) as MarkerTypes
        }
        zoneCode={zoneCode as string}
        activeIndex={9999}
        testID={`${markerType}-selected-marker-${uid}`}
        id={uid}
        isSelected={true}
        withLTP={withLTP}
        isEvChargingOnlyZone={
          !!parkingMethods?.evCharging && !!parkingMethods?.unmanagedParking
        }
        text={
          withCity ? getMarkerLetter(selectedPmc?.parkZone?.name) : undefined
        }
      />
    );
  }
  return <></>;
};

export default SelectedMarker;
